(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("css-element-queries/src/ResizeSensor.js"), require("lodash.debounce"));
	else if(typeof define === 'function' && define.amd)
		define(["css-element-queries/src/ResizeSensor.js", "lodash.debounce"], factory);
	else if(typeof exports === 'object')
		exports["Vueresize"] = factory(require("css-element-queries/src/ResizeSensor.js"), require("lodash.debounce"));
	else
		root["Vueresize"] = factory(root["ResizeSensor"], root["_"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_38__, __WEBPACK_EXTERNAL_MODULE_39__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition